import { BehaviorSubject, catchError, lastValueFrom } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppInfos } from '../app.models'
import { ApiService } from './api.service';
import { HandleError } from '../utils/network-error-handler';
import { environment } from 'src/environments/environment';
import { TauriService } from './tauri/tauri.service';

declare const window: any;

@Injectable({
    providedIn: 'root'
})
export class AppService {
    appVersion$: BehaviorSubject<AppInfos> = new BehaviorSubject({ APP_VERSION_ID: '0.0.0', APP_VERSION_DISPLAY: 'X', APP_COMMIT_SHA: 'Z', APP_ENVIRONMENT: '', TYPE_LICENCE: null, NF525: false });
    isBackendTestEnv = localStorage.getItem('LS_BE_SESSION_TEST_ENV') == '1';
    isFrontofficeTestEnv = localStorage.getItem('LS_FE_SESSION_TEST_ENV') == '1';
    onFOCashdeskChanged$ = new BehaviorSubject<string | null>(localStorage.getItem('LS_FE_AUTH_CASHDESK_GID'));

    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService,
        private _tauriService: TauriService,
    ) {
    }

    get isMobileApp(): boolean {
        return !!window.AndroidApi;
    }

    async getAppVersion() {
        let appInfos: AppInfos;
        if (!!this.isMobileApp) {
            appInfos = JSON.parse(window.AndroidApi.GetAppVersion());
        } else if (this._tauriService.isTauri) {
            appInfos = await this._tauriService.getAppVersion();
        } else {
            appInfos = await lastValueFrom(this._httpClient.get<AppInfos>(this._apiService.endPoints.GetAppVersion).pipe(catchError(error => HandleError(error))));
        }
        this.appVersion$.next(appInfos);
    }

    async isAppUpdated() {
        return await lastValueFrom(this._httpClient.get<boolean>(this._apiService.endPoints.IsAppUpdated)
        .pipe(catchError(error => HandleError(error))));
    }

    async getWorkspaceVersion() {
        const appInfos = await lastValueFrom(this._httpClient.get<AppInfos>(this._apiService.endPoints.GetAppVersion)
        .pipe(catchError(error => HandleError(error))));
        this.appVersion$.next(appInfos);
    }

    async isRunnerConfigurated(accessToken: string) {
        return await lastValueFrom(this._httpClient.get<boolean>(this._apiService.endPointsBO.isRunnerConfiguratedAction_BOAdmSageLink, { headers: { Authorization: 'Bearer ' + accessToken } })
        .pipe(catchError(error => HandleError(error))));
    }

    async doSwitchBOToTestEnvironmentAction() {
        return lastValueFrom(this._httpClient.post<void>(this._apiService.endPointsBO.doSwitchToTestEnvironmentAction_BOPCashDeskSettings, {})
        .pipe(catchError(error => HandleError(error)))).then(() => {
            localStorage.setItem('LS_BE_SESSION_TEST_ENV', '1');
            this.isBackendTestEnv = true;
        });
    }

    async doSwitchFOToTestEnvironmentAction(sessionTestId: string) {
        return lastValueFrom(this._httpClient.post<void>(this._apiService.endPointsFO.doSwitchToTestEnvironmentAction_Session, { SESSION_TEST_ID: sessionTestId })
        .pipe(catchError(error => HandleError(error)))).then(() => {
            localStorage.setItem('LS_FE_SESSION_TEST_ENV', '1');
            localStorage.setItem('LS_FE_SESSION_TEST_ID', sessionTestId);
            this.isBackendTestEnv = true;
        });
    }

    async doDeleteAllIndexedDbs() {
        const dbs = await window.indexedDB.databases()
        dbs.forEach((db: any) => { window.indexedDB.deleteDatabase(db.name) })
    }
}
